import api from "../../services/api";

const path = "v1/volumetria";

export const getVolumetries = async (params = "") => {
  return await api.get(`${path}${params}`);
};
